/** admin/cohorts — API. */
import { http } from '../../_shared/http';
import type { CohortItem, CohortWithStudents } from './types';

export const cohortsApi = {
  list: () => http.get<CohortItem[]>('/cohorts'),
  get: (id: string) => http.get<CohortWithStudents>(`/cohorts/${id}`),
  create: (payload: { name: string; description?: string }) => http.post<CohortItem>('/cohorts', payload),
  update: (id: string, payload: { name?: string; description?: string; isActive?: boolean }) =>
    http.patch<CohortItem>(`/cohorts/${id}`, payload),
  remove: (id: string) => http.del<void>(`/cohorts/${id}`),
  addStudents: (id: string, studentIds: string[]) =>
    http.post<{ added: number }>(`/cohorts/${id}/students`, { studentIds }),
  removeStudents: (id: string, studentIds: string[]) =>
    http.del<{ removed: number }>(`/cohorts/${id}/students`, { studentIds }),
};
